<template>
  <div class="login-page">
    <loading :active.sync="isLoading" loader="dots"></loading>

    <div class="login-wrap" :class="{ 'is-sign': !formIsLogin }">
      <div class="cover-wrap">
        <div class="cover-inner">
          <!-- 登入 -->
          <div class="login-text-wrap">
            <div class="title">
              <LogoLight />
            </div>
            <div class="login-sub-title">
              {{ i18n("User.Sub_Title_01") }}<br />
              {{ i18n("User.Sub_Title_02") }}
            </div>
            <div class="btn-group" @click="$router.push({ name: 'homePage' })">
              {{ i18n("User.Homepage") }}
            </div>
            <div class="btn-group" @click="formIsLogin = !formIsLogin">
              {{ i18n("User.Create_Account") }}
            </div>
          </div>

          <!-- 註冊 -->
          <div class="sign-text-wrap">
            <div class="title">
              <LogoLight />
            </div>
            <div class="sign-sub-title">
              請輸入姓名、帳號、密碼進行註冊。<br />
              如擁有帳號，請點擊登入按鈕登入您的帳戶。
            </div>
            <div class="btn-group" @click="$router.push({ name: 'homePage' })">
              {{ i18n("User.Homepage") }}
            </div>
            <div class="btn-group" @click="formIsLogin = !formIsLogin">
              {{ i18n("User.Login") }}
            </div>
          </div>
        </div>
      </div>
      <div class="login-form-wrap">
        <div class="login-form-inner">
          <!-- 登入 -->
          <ValidationObserver v-slot="{ handleSubmit }">
            <form
              class="login-form"
              @submit.prevent="handleSubmit(candidateSingIn)"
            >
              <h4 class="form-title">應聘者登入</h4>
              <div class="form-group">
                <ValidationProvider
                  name="帳號"
                  rules="required|email"
                  v-slot="{ errors }"
                >
                  <input
                    type="email"
                    maxlength="50"
                    :placeholder="i18n('User.Account')"
                    v-model.lazy="user.Email"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <ValidationProvider
                  name="密碼"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div class="password-input-wrap">
                    <input
                      :type="showPassword ? 'text' : 'password'"
                      maxlength="50"
                      :placeholder="i18n('User.Password')"
                      v-model="user.Password"
                    />
                    <span class="eye-toggle" @click="showPassword = !showPassword">
                      <font-awesome-icon :icon="showPassword ? 'eye' : 'eye-slash'" />
                    </span>
                  </div>
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>

              <button type="submit" class="login-btn">
                {{ i18n("User.Login") }}
              </button>
              <span
                style="display: block; float: right; cursor: pointer"
                @click="forgetPassword"
              >
                {{ i18n("User.Forget_Password") }}
              </span>
              <div class="login-button-group">
                <a
                  v-if="showFB"
                  href="javascript:void(0)"
                  type="button"
                  class="login-social-button facebook-button"
                  @click="loginFB"
                >
                  <eva-icon fill="#3b5998" name="facebook"></eva-icon>
                </a>
                <a
                  v-if="showGoogle"
                  href="javascript:void(0)"
                  id="google-button"
                  type="button"
                  class="login-social-button"
                  @click="click_google = true"
                >
                  <eva-icon fill="#fff" name="google"></eva-icon>
                </a>
              </div>
            </form>
          </ValidationObserver>

          <!-- 註冊 -->
          <ValidationObserver ref="register" v-slot="{ handleSubmit }">
            <form
              class="sign-form"
              @reset.prevent="reset"
              @submit.prevent="handleSubmit(registerAccount)"
            >
              <h4 class="form-title">註冊資訊</h4>
              <div class="form-group">
                <ValidationProvider
                  name="姓名"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <input
                    type="text"
                    maxlength="50"
                    placeholder="請輸入姓名"
                    v-model="register.Name"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <ValidationProvider
                  name="帳號"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <input
                    type="email"
                    maxlength="50"
                    placeholder="請輸入Email"
                    v-model="register.Email"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <ValidationProvider
                  name="密碼"
                  vid="confirmation"
                  rules="required|password_length:8"
                  v-slot="{ errors }"
                >
                  <input
                    type="password"
                    maxlength="50"
                    placeholder="請輸入密碼 (長度須大於等於8)"
                    v-model="register.Password"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <ValidationProvider
                  name="確認密碼"
                  maxlength="50"
                  rules="required|confirmed:confirmation"
                  v-slot="{ errors }"
                >
                  <input
                    type="password"
                    placeholder="請再次輸入密碼"
                    v-model="register.confirmPassword"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <button type="submit" class="login-btn">註冊</button>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <!-- 忘記密碼 Modal -->
    <div
      class="modal fade"
      id="forgetPasswordModal"
      tabindex="-1"
      aria-labelledby="forgetPasswordModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <ValidationObserver v-slot="{ handleSubmit, reset }" ref="form">
            <form @reset.prevent="reset">
              <div class="modal-header">
                <span>忘記密碼</span>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <ValidationProvider
                    ref="forgetPassword"
                    rules="required|email"
                    name="註冊信箱"
                    v-slot="{ errors }"
                  >
                    <label for="">
                      <span class="mark">*</span>
                      註冊信箱
                    </label>
                    <input
                      type="text"
                      placeholder="請輸入註冊信箱"
                      v-model.trim="account"
                    />
                    <span
                      v-if="errors[0]"
                      class="text-danger"
                      style="font-size: 14px"
                    >
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="reset"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="btn btn-success"
                  @click="handleSubmit(sendCode)"
                >
                  送出
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <!-- 變更密碼 Modal -->
    <div
      class="modal fade"
      id="changePasswordModal"
      tabindex="-1"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <ValidationObserver
            ref="changePassword"
            v-slot="{ handleSubmit, reset }"
          >
            <form @reset.prevent="reset">
              <div class="modal-header">
                <span>變更密碼</span>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <ValidationProvider
                    name="新密碼"
                    vid="confirmation"
                    rules="required|password_length:8"
                    v-slot="{ errors }"
                  >
                    <label for="">
                      <span class="mark">*</span>
                      新密碼<span class="mark">(長度須大於等於8)</span>
                    </label>
                    <input
                      type="password"
                      placeholder="請輸入新密碼"
                      v-model.trim="password"
                    />
                    <span
                      v-if="errors[0]"
                      class="text-danger"
                      style="font-size: 14px"
                    >
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
                <div class="form-group">
                  <ValidationProvider
                    name="確認新密碼"
                    rules="required|confirmed:confirmation"
                    v-slot="{ errors }"
                  >
                    <label for="">
                      <span class="mark">*</span>
                      確認新密碼
                    </label>
                    <input
                      type="password"
                      placeholder="請再次輸入密碼"
                      v-model.trim="confirmPassword"
                    />
                    <span
                      v-if="errors[0]"
                      class="text-danger"
                      style="font-size: 14px"
                    >
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
                <div class="form-group">
                  <ValidationProvider
                    name="驗證碼"
                    rules="required|alpha_num"
                    v-slot="{ errors }"
                  >
                    <label for="">
                      <span class="mark">*</span>
                      驗證碼<span class="mark">(已寄至您的信箱)</span>
                    </label>
                    <input
                      type="text"
                      placeholder="請輸入驗證碼"
                      v-model.trim="code"
                    />
                    <span
                      v-if="errors[0]"
                      class="text-danger"
                      style="font-size: 14px"
                    >
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="reset"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="btn btn-success"
                  @click="handleSubmit(changePassword)"
                >
                  確認
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
/*global FB*/
/*global gapi*/
import { mapActions } from "vuex";
import jwt_decode from "jwt-decode";
import LogoLight from "@/components/company/LogoLight.vue";

export default {
  name: "CandidateSignIn",

  components: {
    LogoLight,
  },
  data() {
    return {
      formIsLogin: true,
      showPassword: false,

      // 忘記密碼
      account: null, // 註冊信箱
      password: null, // 欲變更密碼
      confirmPassword: null, // 確認密碼
      code: null, // 驗證碼

      // 登入data
      user: {},

      // 註冊 data
      register: {
        Email: null,
        Password: null,
        confirmPassword: null,
      },

      // 登入後的履歷種類
      IDL_Resume: false,
      DL_Resume: false,

      click_google: false,

      //是否顯示FB按鈕
      showFB: null,
      // 是否顯示google按鈕
      showGoogle: null,
    };
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  methods: {
    // 應聘者 登入
    candidateSingIn() {
      this.$store.dispatch("updateLoading", true);
      this.$api.login.candidateLogin({ ...this.user }).then((response) => {
        if (response.status === 200) {
          const token = response.data;
          const decoded = jwt_decode(token);
          this.$cookies.set("AUTH_TOKEN", token, Infinity);
          this.$cookies.set("candidateAccount", decoded.Account, Infinity); // 登入者帳號
          this.$cookies.set("candidateId", decoded.sub, Infinity);
          this.$common.checkConsentForm();
        }
        this.$store.dispatch("updateLoading", false);
      });
    },

    // fb 登入
    loginFB() {
      const vm = this;
      // 取得使用者登入的狀態
      FB.getLoginStatus((response) => {
        if (response.status === "connected") {
          // 使用者已登入 FB，且授權你的網站使用
          const accessToken = response["authResponse"]["accessToken"];
          vm.loginWithFacebook(accessToken);
        } else if (
          response.status === "not_authorized" || // 使用者已登入 FB，但未授權你的網站使用
          response.status === "unknown" // 使用者未登入 FB，或已從你的網站登出
        ) {
          // 使用 FB 登入
          FB.login(
            function (response) {
              if (response.status === "connected") {
                const accessToken = response["authResponse"]["accessToken"];
                vm.loginWithFacebook(accessToken);
              }
            },
            {
              scope: "email, public_profile",
              return_scopes: true,
            }
          );
        }
      }, true);
    },

    // 使用FB登入
    loginWithFacebook(accessToken) {
      const vm = this;
      const api = `${window.endpoints.api}/auth/loginWithFacebook`;

      const data = JSON.stringify(accessToken);
      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            const token = response.data;
            const decoded = jwt_decode(token);
            vm.$cookies.set("AUTH_TOKEN", token, Infinity);
            vm.$cookies.set("candidateAccount", decoded.Account, Infinity); // 登入者帳號
            vm.$cookies.set("candidateId", decoded.sub, Infinity);
            this.$common.checkConsentForm();
          }
        })
        .catch(() => {
          vm.$store.dispatch("updateLoading", false);
        });
    },

    // 使用Google登入
    loginWithGoogle(id_token) {
      const vm = this;
      const api = `${window.endpoints.api}/auth/loginWithGoogle`;

      const data = JSON.stringify(id_token);
      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            const token = response.data;
            const decoded = jwt_decode(token);
            vm.$cookies.set("AUTH_TOKEN", token, Infinity);
            vm.$cookies.set("candidateAccount", decoded.Account, Infinity); // 登入者帳號
            vm.$cookies.set("candidateId", decoded.sub, Infinity);
            this.$common.checkConsentForm();
          }
        })
        .catch(() => {
          vm.$store.dispatch("updateLoading", false);
        });
    },

    // 應聘者 註冊
    registerAccount() {
      this.updateLoading(true);
      this.$api.register.candidateRegister(this.register).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "註冊成功",
            type: "success",
            duration: 2500,
          });
          this.register = {};
          this.$refs.register.reset();
          this.formIsLogin = !this.formIsLogin;
        }
        this.updateLoading(false);
      });
    },

    // 忘記密碼 Modal
    forgetPassword() {
      this.account = null;
      this.password = null;
      this.confirmPassword = null;
      this.code = null;
      this.$refs.forgetPassword.reset();
      this.$refs.changePassword.reset();
      $("#forgetPasswordModal").modal("show");
    },

    // 發送驗證碼 API
    sendCode() {
      const vm = this;
      const api = `${window.endpoints.api}/auth/user/ForgetPassword/${vm.account}`;

      const data = {
        account: vm.account,
      };

      $("#forgetPasswordModal").modal("hide");
      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            $("#changePasswordModal").modal("show");
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "錯誤",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 變更密碼 API
    changePassword() {
      const vm = this;
      const api = `${window.endpoints.api}/auth/user/ChangePasswordByForgetPassword`;

      const data = {
        Account: vm.account,
        Password: vm.password,
        Code: vm.code,
      };

      $("#changePasswordModal").modal("hide");
      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              title: "成功",
              message: "密碼變更成功",
              type: "success",
              duration: 2500,
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "錯誤",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    onSignIn(user) {
      if (this.click_google) {
        const id_token = user.getAuthResponse().id_token;
        this.loginWithGoogle(id_token);
      }
    },

    // 是否開啟 FB 第三方登入
    openFB() {
      const vm = this;
      const api = `${window.endpoints.api}/BasicInformation/IsEnableFacebookLogin`;

      vm.$http.get(api).then((response) => {
        if (response.status === 200) {
          vm.showFB = response.data;
          if (vm.showFB) {
            vm.getFBKey();
          }
        }
      });
    },
    
    // FB SDK
    loadFacebookSDK() {
      return new Promise((resolve, reject) => {
        if (document.getElementById('facebook-jssdk')) {
          resolve(); // 已經載入
          return;
        }

        const js = document.createElement('script');
        js.id = 'facebook-jssdk';
        js.src = 'https://connect.facebook.net/en_US/sdk.js';
        js.async = true;
        js.defer = true;

        js.onload = () => {
          resolve(); // script 載入成功
        };

        js.onerror = () => {
          reject(new Error('Facebook SDK 載入失敗'));
        };

        const fjs = document.getElementsByTagName('script')[0];
        fjs.parentNode.insertBefore(js, fjs);
      });
    },

    // 取得 FB 金鑰
    async getFBKey() {
      try {
        await this.loadFacebookSDK();

        const fb_response = await this.$http.get(
          `${window.endpoints.api}/BasicInformation/FacebookAppKeys`
        );

        this.$nextTick(() => {
          window.FB.init({
            appId: fb_response.data.AppId,
            cookie: true,
            xfbml: true,
            version: fb_response.data.ApiVersion
          });

          window.FB.AppEvents.logPageView();
        });
      } catch (err) {
        console.error('初始化 Facebook 失敗：', err);
      }
    },
    // async getFBKey() {
    //   const vm = this;
    //   const fb_response = await vm.$http.get(
    //     `${window.endpoints.api}/BasicInformation/FacebookAppKeys`
    //   );
    //   vm.$nextTick(() => {
    //     FB.init({
    //       appId: fb_response.data.AppId,
    //       cookie: true,
    //       xfbml: true,
    //       version: fb_response.data.ApiVersion,
    //     });

    //     FB.AppEvents.logPageView();
    //   });
    // },

    async getGoogleKey() {
      const vm = this;
      const google_response = await vm.$http.get(
        `${window.endpoints.api}/BasicInformation/GoogleAppKeys`
      );
      vm.$nextTick(() => {
        gapi.load("auth2", () => {
          gapi.auth2.init({
            client_id: google_response.data,
          });
        });

        gapi.signin2.render("google-button", {
          "justify-content": "center",
          "align-items": "center",
          padding: "5 5",
          width: "30",
          height: "30",
          onsuccess: vm.onSignIn,
        });
      });
    },

    // 是否開啟 Google 第三方登入
    openGoogle() {
      const vm = this;
      const api = `${window.endpoints.api}/BasicInformation/IsEnableGoogleLogin`;

      vm.$http.get(api).then((response) => {
        if (response.status === 200) {
          vm.showGoogle = response.data;
          if (vm.showGoogle) {
            vm.getGoogleKey();
          }
        }
      });
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  beforeRouteEnter(to, from, next) {
    // 在這裡沒有 this，不過可以在 next 裡面使用 vm 指向元件實體(就是 CandidateSignIn 本身)。
    // next 會直接導向登入頁面，所以不用調整
    localStorage.setItem("PLACE", "/signIn");
    next((vm) => {
      if (vm.$cookies.get("candidateId")) {
        vm.$common.checkConsentForm();
      }
    });
  },

  created() {
    this.openFB();
    this.openGoogle();
  },

  destroyed() {
    this.$notify.close();
    this.click_google = false;
  },
};
</script>

<style lang="scss" scoped>
.login-button-group {
  display: flex;
  margin-top: 10px;
  .login-social-button {
    justify-content: center;
    align-items: center;
    width: 35px;
    margin-right: 4px;
  }
  .facebook-button {
    /deep/ svg.eva {
      background-color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px 5px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
      &:hover {
        box-shadow: 0 0 3px 3px rgba(66, 133, 244, 0.3);
      }
    }
  }
  /deep/ .abcRioButton {
    border-radius: 50px;
  }
}
.login-page {
  height: 100vh;
  position: relative;
  background-image: url("https://cdn.pixabay.com/photo/2016/07/22/16/29/fog-1535201_960_720.jpg");
  background-size: cover;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2;
  }

  @media only screen and (min-width: 768px) {
    .login-wrap {
      background-color: #fff;
      position: absolute;
      display: flex;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 3;
      width: 100%;
      max-width: 960px;
      &::before {
        display: block;
        content: "";
        width: 50%;
        transition: width 0.3s;
      }

      .cover-wrap {
        width: 50%;
        max-width: 960px;
        background-image: url("~@/assets/img/login/background.png");
        background-position: bottom;
        color: #fff;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        transition: left 0.3s;
        overflow: hidden;
        z-index: 5;

        &:after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          background: rgba(16, 63, 108, 0.56);
          z-index: 1;
        }

        &.is-sign {
          &:before {
            width: 0;
          }
          .cover-wrap {
            left: 50%;
            .cover-inner {
              transform: translateX(-100%);
            }
          }

          .login-form-inner {
            transform: translateX(-100%);
          }
        }

        .cover-inner {
          position: relative;
          z-index: 2;
          white-space: nowrap;

          .title {
            font-size: 2.5em;
            font-weight: bold;
            margin-bottom: 75px;
          }

          .login-sub-title,
          .sign-sub-title {
            padding-left: 5px;
            letter-spacing: 1px;
            line-height: 26px;
          }

          .login-sub-title {
            font-size: 1em;
            margin-bottom: 10px;
          }

          .sign-sub-title {
            font-size: 1em;
            margin-top: 100px;
            margin-bottom: 30px;
          }

          .btn-group {
            border: 1px solid #fff;
            color: #fff;
            text-align: center;
            margin-top: 10px;
            display: inline-block;
            margin-right: 15px;
            border-radius: 25px;
            height: calc(1.5em + 0.75rem + 2px);
            padding: 0.375rem 0.75rem;
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.5;
            cursor: pointer;
          }

          .sign-text-wrap,
          .login-text-wrap {
            display: inline-block;
            white-space: initial;
            width: 100%;
            padding: 30px;
            vertical-align: top;
          }
        }
      }

      .login-form-wrap {
        width: 50%;
        white-space: nowrap;
        overflow: hidden;
        .login-form-inner {
          transition: all 0.3s;
          .sign-form,
          .login-form {
            display: inline-block;
            white-space: initial;
            width: 100%;
            padding: 60px;
            vertical-align: top;
          }
        }

        .form-title {
          font-weight: bold;
          text-align: center;
          margin-bottom: 20px;
        }
        label {
          font-size: 0.8em;
          opacity: 0.5;
          display: none;
        }
        input {
          border-radius: 25px;
          background-color: #e5edf6;
          border: none;
          height: calc(1.5em + 0.75rem + 2px);
          padding: 0.375rem 0.75rem;
          font-size: 0.875rem;
          font-weight: 400;
          line-height: 1.5;
          display: block;
          width: 100%;
        }
        .password-input-wrap {
          position: relative;
          input {
            padding-right: 2.25rem;
          }
          .eye-toggle {
            position: absolute;
            right: 0.75rem;
            top: 50%;
            transform: translateY(-50%);
            color: #8a94a6;
            cursor: pointer;
            line-height: 1;
          }
        }
        .login-btn {
          background-color: #164064;
          display: block;
          width: 100%;
          border-radius: 25px;
          color: #fff;
          border: none;
          height: calc(1.5em + 0.75rem + 2px);
          padding: 0.375rem 0.75rem;
          font-size: 0.875rem;
          font-weight: 400;
          line-height: 1.5;
        }
      }

      &.is-sign {
        &:before {
          width: 0;
        }
        .cover-wrap {
          left: 50%;
          .cover-inner {
            transform: translateX(-100%);
          }
        }

        .login-form-inner {
          transform: translateX(-100%);
        }
      }
    }
  }

  @media only screen and (max-width: 767px) {
    .login-wrap {
      width: 95%;
      margin: 0 auto;
      position: relative;
      z-index: 3;
      padding-top: 10px;

      .cover-wrap {
        background-image: url("https://cdn.pixabay.com/photo/2016/07/22/16/29/fog-1535201_960_720.jpg");
        background-position: bottom;
        color: #fff;
        overflow: hidden;
        position: relative;

        &:after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          background: rgba(16, 63, 108, 0.56);
          z-index: 1;
        }

        .cover-inner {
          position: relative;
          z-index: 2;
          white-space: nowrap;
          transition: all 0.2s;

          .title {
            font-size: 1.5em;
            font-weight: bold;
            margin-bottom: 10px;
          }

          .login-sub-title,
          .sign-sub-title {
            padding-left: 5px;
          }

          .login-sub-title {
            font-size: 0.9em;
            margin-bottom: 10px;
          }
          .sign-sub-title {
            font-size: 0.9em;
            margin-bottom: 10px;
          }
          .btn-group {
            border: 1px solid #fff;
            color: #fff;
            text-align: center;
            margin-top: 10px;
            display: inline-block;
            border-radius: 25px;
            margin-right: 15px;
            height: calc(1.5em + 0.75rem + 2px);
            padding: 0.375rem 0.75rem;
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.5;
            cursor: pointer;
          }

          .sign-text-wrap,
          .login-text-wrap {
            display: inline-block;
            white-space: initial;
            width: 100%;
            padding: 30px;
            vertical-align: top;
          }
        }
      }

      .login-form-wrap {
        overflow: hidden;
        background-color: #fff;
        .login-form-inner {
          transition: all 0.2s;

          white-space: nowrap;
          .sign-form,
          .login-form {
            display: inline-block;
            white-space: initial;
            padding: 30px;
            vertical-align: top;
            width: 100%;
          }
        }

        .form-title {
          font-weight: bold;
          text-align: center;
          margin-bottom: 20px;
        }
        label {
          font-size: 0.8em;
          opacity: 0.5;
          display: none;
        }
        input {
          border-radius: 25px;
          margin-bottom: 20px;
          background-color: #e5edf6;
          border: none;
          height: calc(1.5em + 0.75rem + 2px);
          padding: 0.375rem 0.75rem;
          font-size: 0.875rem;
          font-weight: 400;
          line-height: 1.5;
          display: block;
          width: 100%;
        }
        .password-input-wrap {
          position: relative;
          input {
            padding-right: 2.25rem;
          }
          .eye-toggle {
            position: absolute;
            right: 0.75rem;
            top: 50%;
            transform: translateY(-50%);
            color: #8a94a6;
            cursor: pointer;
            line-height: 1;
          }
        }
        .login-btn {
          background-color: #164064;
          display: block;
          width: 100%;
          border-radius: 25px;
          color: #fff;
          border: none;
          height: calc(1.5em + 0.75rem + 2px);
          padding: 0.375rem 0.75rem;
          font-size: 0.875rem;
          font-weight: 400;
          line-height: 1.5;
        }
      }

      &.is-sign {
        .cover-inner {
          transform: translateX(-100%);
        }
        .login-form-inner {
          transform: translateX(-100%);
        }
      }
    }
  }
}

#forgetPasswordModal {
  .modal-content {
    border: none;
    -webkit-box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    position: relative;
    .modal-header {
      display: block;
      span {
        padding: 10px 0;
        font-size: 1.2em;
        font-weight: lighter;
        letter-spacing: 1px;
        display: block;
        position: relative;
      }
    }
    .modal-body {
      padding: 40px;
      .form-group {
        label {
          display: block;
          font-size: 0.9em;
          margin-bottom: 5px;
        }
        input {
          width: 100%;
          border: none;
          background-color: #f3f4ff;
          line-height: 30px;
        }
      }
    }
  }
}

#changePasswordModal {
  .modal-content {
    border: none;
    -webkit-box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    position: relative;
    .modal-header {
      display: block;
      border-bottom: none;
      span {
        padding: 10px 0;
        font-size: 1.2em;
        font-weight: lighter;
        letter-spacing: 1px;
        display: block;
        border-bottom: 1px solid #ccc;
        position: relative;
        &::after {
          content: "";
          width: 100px;
          height: 5px;
          position: absolute;
          left: 0;
          bottom: -3px;
          background-color: #eca517;
        }
      }
    }
    .modal-body {
      padding: 40px;
      .form-group {
        label {
          display: block;
          font-size: 0.9em;
          margin-bottom: 5px;
        }
        input {
          width: 100%;
          border: none;
          background-color: #f3f4ff;
          line-height: 30px;
        }
      }
    }
  }
}
</style>
